import AbstractJobApplyForm from "./job_apply_forms";
import $jsAPI from "../../front_end_api";

class StepBasicInfo extends AbstractJobApplyForm {

  constructor(currentStepFormId) {
    super(currentStepFormId);
    this.haveCaptcha = !window.draftJobApplication;

    this.initPage();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.$customFields !== 'undefined' && document.getElementById('job-apply-form-step-basic-info')) {
    new StepBasicInfo('job-apply-form-step-basic-info');
    $jsAPI.fireEvent('job:application_form_opened', window.job, window.draftJobApplication);
  }
});
